var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("text-area", {
    attrs: {
      "non-unique-id": "diagnosis-notes-" + _vm.stay_id,
      maxlength: "700",
      label: "Additional Notes"
    },
    model: {
      value: _vm.notes,
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }